import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./breadcrumb.css";

const Breadcrumb = () => {
  const location = useLocation();
  const [, setCurrentHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [setCurrentHash]);

  let test = window.location.href.split("/");

  test.reverse();
  test.pop();
  test.pop();
  test.pop();
  test.reverse();

  let latest = [];
  for (let i = 0; i < test.length; i++) {
    const cleanPart = test[i].split("#")[0];
    if (isNumeric(cleanPart)) {
      latest[latest.length - 1] += " " + cleanPart;
    } else {
      latest.push(cleanPart);
    }
  }

  function isNumeric(str) {
    if (typeof str != "string") return false;
    return !isNaN(str) && !isNaN(parseFloat(str));
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function isValid(string) {
    if (string.length > 1) return string;
  }

  return (
    <div className={"containerBreadcrumb"}>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21.826" viewBox="0 0 16.369 21.826">
        <path
          id="Icon_awesome-map-marker-alt"
          data-name="Icon awesome-map-marker-alt"
          d="M7.343,21.385C1.15,12.406,0,11.485,0,8.185a8.185,8.185,0,0,1,16.369,0c0,3.3-1.15,4.221-7.343,13.2a1.024,1.024,0,0,1-1.682,0Zm.841-9.79a3.41,3.41,0,1,0-3.41-3.41A3.41,3.41,0,0,0,8.185,11.595Z"
          fill="#ffffff"
        />
      </svg>
      <div className="testBreadcrumb">
        <div className="home">
          <Link to={`/`} className="urlLinkHome">
            Accueil
          </Link>
        </div>

        {isValid(latest[0]) ? (
          <>
            <div className={"slash"}>/</div>

            {location.pathname === "/moncompte" ? (
              <div>Mon Compte</div>
            ) : (
              <div className={"home"}>
                {latest[0] === "fiches" ? (
                  <Link to={"/fiches"} className="urlLink">
                    <div>Fiches Pratiques</div>
                  </Link>
                ) : latest[0] === "categorie" ? (
                  latest[1].includes("#") ? (
                    <Link to={"/categorie/" + latest[1].substring(0, latest[1].indexOf("#"))} className="urlLink">
                      {latest[1].substring(0, latest[1].indexOf("#")) === "prets" ? (
                        <div>Prêts, garanties et mainlevées</div>
                      ) : (
                        capitalizeFirstLetter(latest[1].substring(0, latest[1].indexOf("#")))
                      )}
                    </Link>
                  ) : (
                    <Link to={"/categorie/" + latest[1]} className="urlLink">
                      {latest[1] === "prets" ? (
                        <div>Prêts, garanties et mainlevées</div>
                      ) : (
                        capitalizeFirstLetter(latest[1])
                      )}
                    </Link>
                  )
                ) : latest[0] === "avis" ? (
                  <Link to={"/avis"} className="urlLink">
                    <div>Avis d'Experts</div>
                  </Link>
                ) : latest[0].includes("#") ? (
                  <Link to={"/" + latest[0].substring(0, latest[0].indexOf("#"))} className="urlLink">
                    {capitalizeFirstLetter(latest[0].substring(0, latest[0].indexOf("#")))}
                  </Link>
                ) : latest[0] === "pratique" || latest[0] === "pratiques" ? (
                  <Link to={"/pratique"} className="urlLink">
                    <div>Manuels PRATIQUES</div>
                  </Link>
                ) : latest[0] === "SchemaFiscalite" ? (
                  <Link to={"/SchemaFiscalite"} className="urlLink">
                    <div>La fiscalité immobilière</div>
                  </Link>
                ) : latest[0] === "AnalysePatrimoniale" ? (
                  <Link to={"/AnalysePatrimoniale"} className="urlLink">
                    <div>Analyse patrimoniale</div>
                  </Link>
                ) : latest[0] === "tarif_des_notaires" ? (
                  <Link to={"/tarif_des_notaires"} className="urlLink">
                    <div>L’essentiel de la taxe des actes</div>
                  </Link>
                ) : (
                  <Link to={"/" + latest[0]} className="urlLink">
                    {capitalizeFirstLetter(latest[0])}
                  </Link>
                )}
              </div>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Breadcrumb;
